import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DecisionRolePageComponent } from './decision-role-page.component';

const routes: Routes = [
  {
    path : '',
    component : DecisionRolePageComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DecisionRolePageRoutingModule { }
